export const surveyKeys = {
  surveyResult: "survey-result",
  surveyForm: "survey-form",
  surveysList: "surveys-list"
};
